import { render, staticRenderFns } from "./wx.vue?vue&type=template&id=bf2d4278&scoped=true"
import script from "./wx.vue?vue&type=script&lang=js"
export * from "./wx.vue?vue&type=script&lang=js"
import style0 from "./wx.vue?vue&type=style&index=0&id=bf2d4278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2d4278",
  null
  
)

export default component.exports